<mat-tab-group *ngIf="driversOnShiftV2$ | async as onShift" lohiPageTitle="Driver Shifts">
  <mat-tab *ngFor="let tabRegion of onShift.regions; trackBy: 'id' | trackByKey">
    <ng-template mat-tab-label>
      <span>{{ tabRegion.name }}</span>
      <lohi-number-badge [count]="getBelowCommit(tabRegion.overviews)"></lohi-number-badge>
    </ng-template>
    <div class="flex flex-col lg:flex-row p-1 lg:p-3 h-full">
      <div class="flex-1">
        <div class="font-bold pb-3 text-2xl">Capacity</div>
        <div>
          <div
            *ngFor="let region of onShift?.regions; trackBy: 'id' | trackByKey; let i = index"
            [class.mt-2]="i !== 0"
          >
            <lohi-shift-chart-v2
              *ngIf="region.id === tabRegion.id"
              (barSelected)="setFilterDate($event)"
              [earningsPerDay]="region"
            ></lohi-shift-chart-v2>
          </div>
        </div>
        <div class="mt-2">
          <div class="card-with-shadow bg-white p-2 mb-2 w-full">
            <div class="flex flex-row justify-between">
              <div class="text-lg font-bold">Regional Stats</div>
              <mat-slide-toggle
                [color]="'primary'"
                [formControl]="qualifiedDriversRegionalStatsToggle"
                *lohiFeatureFlag="'qualifiedDriversRegionalStats'"
                >Display the Loads and Sites your Drivers are Qualified for
              </mat-slide-toggle>
            </div>
            <div *ngFor="let region of regionalOrderStats$ | async; trackBy: 'id' | trackByKey">
              <div class="text-gray-700" *ngIf="region.id === tabRegion.id && region.upForGrabsCount > 0">
                Some urgent loads are available. Bring a driver online now to claim these loads.
              </div>
              <div *ngIf="region.id === tabRegion.id" class="py-2 flex flex-row">
                <div class="flex flex-col justify-between mr-2 w-2/3">
                  <div class="text-lg font-bold">{{ region.name }}</div>
                  <ng-container *lohiFeatureFlag="'qualifiedDriversRegionalStats'; else allRegionalStats">
                    <ng-container *ngIf="qualifiedDriversRegionalStatsToggle.value; else allRegionalStats">
                      <div *ngIf="region.qualifiedNoLoadsAvailableMessage" class="h-full flex flex-col">
                        <div class="whitespace-pre-wrap text-left italic">
                          {{ region.qualifiedNoLoadsAvailableMessage }}
                        </div>
                      </div>
                      <div *ngIf="region.qualifiedNoLoadsAvailableMessage" class="flex justify-end text-gray-700">
                        last updated {{ region.qualifiedNoLoadsAvailableCreatedAt | standardDate }}
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-template #allRegionalStats>
                    <div *ngIf="region.noLoadsAvailableMessage" class="h-full flex flex-col">
                      <div class="whitespace-pre-wrap text-left italic">{{ region.noLoadsAvailableMessage }}</div>
                    </div>
                    <div *ngIf="region.noLoadsAvailableMessage" class="flex justify-end text-gray-700">
                      last updated {{ region.noLoadsAvailableCreatedAt | standardDate }}
                    </div>
                  </ng-template>
                </div>
                <div class="flex flex-col pl-2 border-l border-gray-400 w-1/3">
                  <div class="flex-col justify-between" *lohiFeatureFlag="'longestWaitingDriver'; else medianSeconds">
                    <div class="flex flex-row items-center">
                      Longest Waiting Driver And List
                      <mat-icon class="text-gray-600 cursor-pointer" tooltip="The longest current wait time"
                        >info
                      </mat-icon>
                    </div>
                    <div *ngIf="region.medianSecondsToDispatchByOrderCount?.length; else nobodyWaiting">
                      <div
                        *ngFor="
                          let orderCount of region.medianSecondsToDispatchByOrderCount;
                          trackBy: 'orderCount' | trackByKey
                        "
                        class="flex justify-between even:bg-gray-300 px-1 cursor-pointer py-2"
                        (click)="showListOfDriversWaiting(region, orderCount.orderCount)"
                      >
                        <div class="text-blue-500 font-semibold flex flex-row items-center">
                          <div
                            *ngIf="(orderCount.waitingDrivers | triangle | async) > 0"
                            class="text-red-500 mr-1"
                            tooltip="Drivers Not Accepting Loads – These drivers have not responded to loads they have been sent, or are not online and available to be sent loads."
                          >
                            <mat-icon>warning</mat-icon>
                          </div>
                          {{ orderCount.orderCount + 1 | ordinal: true }} Load
                        </div>
                        <div *ngIf="orderCount.waitingDrivers?.length">
                          {{ orderCount.waitingDrivers[0].secondsWaiting | prettyPrintSeconds }}
                        </div>
                        <div *ngIf="!orderCount.waitingDrivers?.length">N/A</div>
                      </div>
                    </div>
                    <ng-template #nobodyWaiting>
                      <span class="italic text-gray-600">No Drivers are waiting</span>
                    </ng-template>
                  </div>
                  <ng-template #medianSeconds>
                    <div>
                      Median Time To Dispatch
                      <mat-icon
                        class="text-gray-600 cursor-pointer"
                        tooltip="The median time it takes for a driver to get this load on their shift"
                        >info
                      </mat-icon>
                    </div>
                    <div *ngIf="region.medianSecondsToDispatchByOrderCount?.length; else calculating">
                      <div
                        *ngFor="
                          let orderCount of region.medianSecondsToDispatchByOrderCount;
                          trackBy: 'orderCount' | trackByKey
                        "
                        class="ml-1 flex justify-between even:bg-gray-300 px-1"
                      >
                        <div>{{ orderCount.orderCount + 1 | ordinal: true }} Load</div>
                        <div *ngIf="orderCount.sampleSize > 0">
                          {{ orderCount.medianSecondsToDispatch | prettyPrintSeconds }}
                        </div>
                        <div *ngIf="orderCount.sampleSize === 0">
                          <span class="italic text-gray-600">Not Enough Data</span>
                        </div>
                      </div>
                    </div>
                    <ng-template #calculating>
                      <span class="italic text-gray-600">Still Calculating</span>
                    </ng-template>
                  </ng-template>
                  <div class="py-2">
                    <div class="flex justify-between">
                      <div>Up For Grabs</div>
                      <ng-container *lohiFeatureFlag="'qualifiedDriversRegionalStats'; else allUpForGrabsLoads">
                        <ng-container *ngIf="qualifiedDriversRegionalStatsToggle.value; else allUpForGrabsLoads">
                          <ng-container *ngIf="region.qualifiedUpForGrabsCount > 0; else noUpForGrabsLoads">
                            <div class="flex ml-1 mr-1">
                              <span
                                style="width: 10px; height: 20px"
                                class="rounded-tl-full rounded-bl-full bg-red-500"
                              >
                              </span>
                              <span
                                style="height: 20px"
                                class="text-sm text-white flex justify-center leading-none items-center bg-red-500"
                              >
                                <span
                                  >{{ region.qualifiedUpForGrabsCount }} load<ng-container
                                    *ngIf="region.qualifiedUpForGrabsCount !== 1"
                                    >s</ng-container
                                  ></span
                                >
                              </span>
                              <span
                                style="width: 10px; height: 20px"
                                class="rounded-tr-full rounded-br-full bg-red-500"
                              >
                              </span>
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-template #allUpForGrabsLoads>
                        <ng-container *ngIf="region.upForGrabsCount > 0; else noUpForGrabsLoads">
                          <div class="flex ml-1 mr-1">
                            <span style="width: 10px; height: 20px" class="rounded-tl-full rounded-bl-full bg-red-500">
                            </span>
                            <span
                              style="height: 20px"
                              class="text-sm text-white flex justify-center leading-none items-center bg-red-500"
                            >
                              <span
                                >{{ region.upForGrabsCount }} load<ng-container *ngIf="region.upForGrabsCount !== 1"
                                  >s</ng-container
                                ></span
                              >
                            </span>
                            <span style="width: 10px; height: 20px" class="rounded-tr-full rounded-br-full bg-red-500">
                            </span>
                          </div>
                        </ng-container>
                      </ng-template>
                      <ng-template #noUpForGrabsLoads>
                        <div class="mr-1">No Loads</div>
                      </ng-template>
                    </div>
                    <ng-container *ngIf="region.upForGrabsCount > 0">
                      <div
                        class="min-w-full text-gray-700"
                        *ngIf="(driversAvailableByRegionCount$ | async)[region.id] as count"
                      >
                        You have {{ count }} driver
                        <ng-container *ngIf="count !== 1">s</ng-container>
                        who might be available! Bring them on shift to get these loads while they last...
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-container *lohiRelationship="'saas'">
          <div *lohiFeatureFlag="'carrierCommitments'" class="mt-2">
            <lohi-commitment-calendar [region]="tabRegion.id"></lohi-commitment-calendar>
          </div>
        </ng-container>
      </div>
      <div class="w-full lg:w-1/3 lg:ml-3 mt-2 lg:mt-0">
        <div class="mb-2">
          <lohi-driver-list [region]="{id:tabRegion.id, name: tabRegion.name}" #driverList></lohi-driver-list>
        </div>
      </div>
    </div>
  </mat-tab>
  <ng-container *ngIf="regionalOrderStats$ | async">
    <mat-tab *lohiFeatureFlag="'dashboardv3'">
      <ng-template mat-tab-label> Mixed Loads</ng-template>
      <div class="grid grid-cols-3 gap-3 m-3">
        <a
          class="flex flex-row justify-between card-with-shadow bg-white items-center"
          [routerLink]="['/', 'drivers', data.id]"
          *ngFor="let data of reloadStats$ | async; trackBy: 'phone' | trackByKey"
        >
          <div class="p-2 text-lg font-semibold">
            {{ data.name }}
          </div>
          <div class="flex flex-row">
            <div *ngIf="data.shiftEnd">
              <div class="p-2 bg-green-400 flex flex-col">
                <div class="text-xs text-white">Remaining HOS</div>
                <div class="font-semibold text-white">{{ data.shiftEnd | countdown | async }}</div>
              </div>
            </div>
            <a [routerLink]="['/', 'loads', data.uniqueId]">
              <div class="p-2 bg-blue-500 flex flex-col">
                <div class="text-xs text-white">Current Load</div>
                <span class="font-semibold text-white">{{ data.uniqueId }}</span>
              </div>
            </a>
          </div>
        </a>
      </div>
    </mat-tab>
    <mat-tab *lohiFeatureFlag="'dashboardv3'">
      <ng-template mat-tab-label> Equipment And Other</ng-template>
      <div class="grid grid-cols-3 gap-3 m-3">
        <a
          class="flex flex-row justify-between card-with-shadow bg-white"
          [routerLink]="['/', 'drivers', data.id]"
          *ngFor="let data of hauliStats$ | async; trackBy: 'phone' | trackByKey"
        >
          <div class="text-lg font-semibold p-2">
            {{ data.name }}
          </div>
          <div class="flex flex-row">
            <div *ngIf="data.shiftEnd">
              <div class="p-2 bg-green-400 flex flex-col">
                <div class="text-xs text-white">Remaining HOS</div>
                <div class="font-semibold text-white">{{ data.shiftEnd | countdown | async }}</div>
              </div>
            </div>
            <a [routerLink]="['/', 'loads', data.uniqueId]">
              <div class="p-2 bg-blue-500 flex flex-col">
                <div class="text-xs text-white">Current Load</div>
                <span class="font-semibold text-white">{{ data.uniqueId }}</span>
              </div>
            </a>
          </div>
        </a>
      </div>
    </mat-tab>
  </ng-container>
</mat-tab-group>

<ng-template #driversWaiting>
  <ng-container *ngIf="selectedRegionStats$$ | async as regionStats">
    <div matDialogTitle>
      Drivers Waiting For {{ (selectedOrderCount$$ | async) + 1 | ordinal: true }} Load ({{ regionStats.name }})
    </div>
    <div matDialogContent>
      <ng-container *ngIf="selectedWaitingDrivers$ | async as selectedWaitingDrivers; else noDriversWaiting">
        <ng-container *ngIf="selectedWaitingDrivers?.length; else noDriversWaiting">
          <div class="grid grid-cols-2 py-2">
            <div class="font-bold mb-1">Name</div>
            <div class="font-bold mb-1 text-right">Time Waiting</div>
            <ng-container *ngFor="let driver of selectedWaitingDrivers; trackBy: 'phone' | trackByKey">
              <ng-container *ngIf="driver.phone | userFromPhone | async as user">
                <div class="flex flex-col py-2">
                  <a class="text-blue-500 flex flex-row" [routerLink]="['/', 'drivers', user.id]" matDialogClose>
                    <div *ngIf="!!user.actionNeeded" class="text-red-500 mr-1">
                      <mat-icon>warning</mat-icon>
                    </div>
                    {{ user.driverName }}
                  </a>
                  <div *ngIf="!!user.actionNeeded" class="text-red-500 mr-1">
                    {{ user.actionNeeded.actionNeededTitle }}
                  </div>
                </div>
                <div class="text-right py-2">{{ driver.secondsWaiting | prettyPrintSeconds }}</div>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
        <div></div>
      </ng-container>
      <ng-template #noDriversWaiting>
        <div class="italic text-gray-600">No Drivers Are Waiting</div>
      </ng-template>
    </div>
  </ng-container>
</ng-template>
